/**
 * View - Base class for rendered views (extends Module with View styles)
 *
 * Simple extension of Module that adds View-specific stylesheet. Foundation for
 * Page and Overlay components.
 *
 * ARCHITECTURE: Fifth level (Ancestor → Class → Controller → Module → View)
 * Extended by Page and Overlay for full-page and modal components.
 *
 * @class View
 * @extends Module
 *
 * @example
 * // Typically not used directly - extend Page or Overlay instead
 * const MyView = View.inherit({
 *     namespace: 'MyView'
 * });
 */
define("View", [`Module`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		constructor(setup) {
			this.addClass(`View`);

			return this.DOM.loadStylesheet({
				href: `/View.css`,
			});
		},
	});
});

//# sourceMappingURL=View.js.map